import { datadogRum, type RumInitConfiguration } from '@datadog/browser-rum';

export function tracesApplication(url: string): boolean {
  try {
    const target = new URL(url, window.location.href);
    return target.origin === window.location.origin;
  } catch {
    return false;
  }
}

function withoutQuery(url: string): string {
  try {
    const parsed = new URL(url, window.location.href);
    parsed.search = '';
    parsed.hash = '';
    return parsed.toString();
  } catch {
    return '[INVALID URL]';
  }
}

// A failed or unconfigured collector must never prevent the application from mounting.
export async function initializeRum(): Promise<void> {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 1500);
  try {
    const response = await fetch('/observability/rum-config', { signal: controller.signal });
    if (!response.ok) return;
    const configuration = (await response.json()) as RumInitConfiguration | null;
    if (!configuration?.applicationId || !configuration.clientToken) return;
    datadogRum.init({
      ...configuration,
      allowedTracingUrls: [
        { match: tracesApplication, propagatorTypes: ['datadog', 'tracecontext'] },
      ],
      traceSampleRate: 100,
      beforeSend(event) {
        event.view.url = withoutQuery(event.view.url);
        if (event.type === 'resource') event.resource.url = withoutQuery(event.resource.url);
        return true;
      },
    });
  } catch {
    // RUM is optional; authentication and application error handling remain independent.
  } finally {
    clearTimeout(timeout);
  }
}
